module.exports = __webpack_public_path__ + "static/exercise-img-10-0455d1193a9b70c16d5f63e12e17b5b5.png";